import { Type } from 'class-transformer';
import { IsBoolean, IsEmail, IsInt, IsNumber, IsString } from 'class-validator';
import { GiftCardDto } from './giftCard.dto';
import { GiftCardTypeDto } from './giftCardType.dto';
import { GiftCardAddressDto } from './giftCardAddress.dto';
import { BaseDto } from '../base.dto';
import { MerchantDto } from '../merchant.dto';

export class GiftCardPhysicalCardDto extends BaseDto {
  @IsNumber()
  public amount: number;

  @IsString()
  public customerName: string;

  @IsString()
  public fromName: string;

  @IsString()
  @IsEmail()
  public customerEmail: string;

  @IsString()
  @IsEmail()
  public fromEmail: string;

  @IsString()
  public message?: string;

  @IsBoolean()
  public acceptsMarketingTerms: boolean;

  @IsBoolean()
  public acceptTerms: boolean;

  @IsBoolean()
  public processed?: boolean;

  @Type(() => GiftCardTypeDto)
  public giftCardType: GiftCardTypeDto;

  @Type(() => GiftCardDto)
  public giftCard?: GiftCardDto;

  @IsString()
  public customerPhoneNumber?: string;

  @IsBoolean()
  public active?: boolean;

  @Type(() => MerchantDto)
  public merchant?: MerchantDto;

  @Type(() => GiftCardAddressDto)
  public giftCardAddress?: GiftCardAddressDto[];
}
